var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#a0b1c4;}")),React.createElement("g",{"transform":"translate(-7.5 -7.5)","key":1},React.createElement("path",{"className":"a","d":"M28.5,9.62,26.38,7.5,18,15.88,9.62,7.5,7.5,9.62,15.88,18,7.5,26.38,9.62,28.5,18,20.12l8.38,8.38,2.12-2.12L20.12,18Z"}))]);
}

Close.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = Close;

Close.default = Close;
